import { CardDescription, CardFooter } from "@/components/ui/card";
import { Link } from "react-router";

export const AuthenticationFormFooter: React.FC<AuthenticationFormFooterProps> = ({ content, link }) => (
	<CardFooter className="text-white/70 flex justify-center gap-1">
		<CardDescription> {content}</CardDescription>

		{link && (
			<Link to={link.linkTo} className="text-sm text-gray-400 underline-offset-4 hover:underline">
				{link.linkText}
			</Link>
		)}
	</CardFooter>
);

interface AuthenticationFormFooterProps {
	content: string;
	link?: {
		linkTo: string;
		linkText: string;
	};
}
